import { render } from "./ModuliRead.vue?vue&type=template&id=20a8ce19"
import script from "./ModuliRead.vue?vue&type=script&lang=js"
export * from "./ModuliRead.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__